import { cn } from '@/lib/utils';
import type { LiveSignal } from '@/lib/intake/detectLiveSignals';

interface LiveSignalBarProps {
  signals: LiveSignal[];
}

export const LiveSignalBar = ({ signals }: LiveSignalBarProps) => {
  if (signals.length === 0) return null;

  return (
    <div className="mt-3 flex items-center gap-1.5 flex-wrap animate-fade-in">
      <span className="text-[11px] font-medium text-muted-foreground/60 uppercase tracking-wider mr-1">
        Erkannt:
      </span>
      {signals.map((signal) => (
        <span
          key={signal.key}
          className={cn(
            'text-[12px] text-muted-foreground/70 px-2 py-0.5 rounded-md',
            'bg-muted/40 border border-border/30',
            'animate-fade-in transition-all duration-300',
          )}
        >
          {signal.label}
        </span>
      ))}
    </div>
  );
};
